import { globalHistory, NavigateOptions } from '@reach/router'
import { resolve } from '@reach/router/es/lib/utils'
import { useCallback, useEffect, useState } from 'react'

export const useLocation = () => {
  const [location, setLocation] = useState(globalHistory.location)

  useEffect(() => {
    const removeListener = globalHistory.listen(params => {
      setLocation(params.location)
    });
    return () => {
      removeListener();
    };
  }, []);

  const navigate = useCallback((to: any, options?: NavigateOptions<{}>) => {
    return globalHistory.navigate(resolve(to, location.pathname), options)
  }, [location])

  return { location, navigate, listen: globalHistory.listen };
}